import { sizes } from "../utils";
import type { MontaSVGProps } from "../types";
const GrowUp = ({
  size = "medium",
  color = "inherit",
  ...props
}: MontaSVGProps) => {
  const computedSize = sizes[size] || size;
  props.style = {
    ...props.style,
    color
  };
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill={color}
      viewBox="0 0 20 20"
      width={computedSize}
      height={computedSize}
      {...props}
    >
      <circle cx={10} cy={10} r={10} fill="#1AD598" fillOpacity={0.2} />
      <path
        fill="#1AD598"
        fillRule="evenodd"
        d="M4.931 13.14a.733.733 0 0 1 0-1.033l3.122-3.116a.727.727 0 0 1 1.122.107l1.064 1.6 2.217-2.212h-1.153a.73.73 0 1 1 0-1.46h2.928c.403.001.73.327.732.73v2.921a.732.732 0 0 1-1.463 0V9.51l-2.859 2.854a.724.724 0 0 1-1.122-.107l-1.064-1.6-2.489 2.482a.73.73 0 0 1-1.034 0z"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default GrowUp;
